<script lang="ts">
  import '../app.css';
  import { onMount } from 'svelte';
  import { registerSW } from 'virtual:pwa-register';

  onMount(() => {
    // Activate the revised cache (PR #4), but keep the working timer view.
    // The new shell is picked up on the user's next navigation or reload.
    registerSW({ immediate: true, onNeedReload: () => {} });
  });
</script>

<slot />
